import { render, staticRenderFns } from "./BannerDemo.vue?vue&type=template&id=c91723c2&scoped=true&"
import script from "./BannerDemo.vue?vue&type=script&lang=js&"
export * from "./BannerDemo.vue?vue&type=script&lang=js&"
import style0 from "./BannerDemo.vue?vue&type=style&index=0&id=c91723c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91723c2",
  null
  
)

export default component.exports